<template>
  <client-only>
    <div v-if="brandUpgradeNoticeVisible" :class="[isDesktop ? 'desktop' : '']">
      <div class="brand-upgrade-notice-bar">
        <!-- 滚动文本区：最大宽度 1080px -->
        <div class="brand-upgrade-notice-bar__main">
          <div class="brand-upgrade-notice-bar__scroll">
            <span class="brand-upgrade-notice-bar__text">
              <span class="brand-upgrade-notice-bar__inner">{{
                $t('common.brand_upgrade_notice')
              }}</span>
              <span
                class="brand-upgrade-notice-bar__inner"
                aria-hidden="true"
                >{{ $t('common.brand_upgrade_notice') }}</span
              >
            </span>
          </div>
        </div>
        <!-- 关闭按钮：固定在通知条整体布局的右侧 -->
        <button
          type="button"
          class="brand-upgrade-notice-bar__close"
          :aria-label="$t('common.close')"
          @click="handleClose"
        >
          <span class="brand-upgrade-notice-bar__close-icon">×</span>
        </button>
      </div>
    </div>
  </client-only>
</template>

<script>
  /**
   * 品牌升级通知条。显示状态已同步到 Vuex common 模块，
   * 其它页面可通过以下方式获取是否显示：
   * - mapState('common', ['brandUpgradeNoticeVisible'])
   * - mapGetters(['brandUpgradeNoticeVisible'])  // 根 getter 别名
   * - this.$store.state.common.brandUpgradeNoticeVisible
   * - this.$store.getters.brandUpgradeNoticeVisible
   */
  import { mapState, mapMutations } from 'vuex'
  import dayjs from 'dayjs'
  import { storage } from '@/utils/storage'
  import { BRAND_UPGRADE_NOTICE_CLOSED } from '@/utils/storage'

  // 截至显示时间：3 月 31 号之后不再展示
  const END_DISPLAY_DATE = '2026-03-31'

  export default {
    name: 'BrandUpgradeNoticeBar',
    computed: {
      ...mapState(['isDesktop']),
      // 从 store 读取，供本组件展示；其它页面也可通过 store 获取
      ...mapState('common', ['brandUpgradeNoticeVisible']),
    },
    mounted() {
      this.checkAndShow()
    },
    methods: {
      ...mapMutations('common', ['setBrandUpgradeNoticeVisible']),
      checkAndShow() {
        if (typeof window === 'undefined' || !storage.support) return

        // 用户点关闭后不再显示
        const closed = storage.get(BRAND_UPGRADE_NOTICE_CLOSED)
        if (closed === true || closed === 'true') {
          this.setBrandUpgradeNoticeVisible(false)
          return
        }

        // 截至 3 月 31 号，之后不再展示
        const today = dayjs().format('YYYY-MM-DD')
        if (today > END_DISPLAY_DATE) {
          this.setBrandUpgradeNoticeVisible(false)
          return
        }

        this.setBrandUpgradeNoticeVisible(true)
      },
      handleClose() {
        storage.set(BRAND_UPGRADE_NOTICE_CLOSED, true)
        this.setBrandUpgradeNoticeVisible(false)
      },
    },
  }
</script>

<style scoped lang="scss" src="./styles.scss"></style>
